import React from "react";
import styles from "./ContactPage.scss";
import SiteContainer from "components/homepage/SiteContainer";
import ContactForm from "components/shared/widgets/ContactForm";

export default function ContactPage(props) {
    return (
        <SiteContainer minimal>
            <div className={styles.root}>
                <header>
                    <h2>Contact Us</h2>
                    <h4>Please use this form to contact us with any questions:</h4>
                </header>
                <div className={styles.contactForm}>
                    <ContactForm />
                </div>
            </div>
        </SiteContainer>
    );
}
